<template>
  <div class="crud">
    <div class="notification">
      <notification-message />
    </div>

    <!-- Start Array -->
    <div class="crudArray">
      <v-data-table
        :headers="headers"
        :items="masterInterventionsFiltered"
        :search="search"
        :footer-props="{ showFirstLastPage: true }"
        disable-sort
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ $t("crudIntParent.title") }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-text-field
              id="search-intparent"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('crudIntParent.searchIntParent')"
              single-line
              hide-details
              color="grey"
            >
            </v-text-field>
            <v-divider class="mx-4" inset vertical> </v-divider>
            <v-select
              v-model="filterTypes"
              :items="types"
              :label="$t('crudIntParent.filters.typeField')"
              multiple
              small-chips
              hide-details
              color="red"
              style="max-width: 280px"
            >
            </v-select>
            <v-divider class="mx-4" inset vertical> </v-divider>
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-combobox
                  v-model="filterDate"
                  multiple
                  small-chips
                  :label="$t('crudIntParent.filters.dateField')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  style="max-width: 280px"
                  clearable
                >
                </v-combobox>
              </template>
              <v-date-picker v-model="filterDate" no-title range multiple>
              </v-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="button-new-intparent"
                  color="red darken-1"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t("crudIntParent.new") }}
                </v-btn>
              </template>
              <!-- Start Form -->
              <v-card v-if="editedItem">
                <v-form ref="form" v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="5">
                          <v-text-field
                            id="intparent-slug"
                            v-model="editedItem.slug"
                            :label="$t('crudIntParent.slugParent')"
                            :rules="inputText"
                            required
                            color="grey"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-autocomplete
                            id="intparent-type"
                            v-model="editedItem.type"
                            :items="$enumInterventionStatus"
                            item-text="text"
                            item-value="value"
                            :label="$t('crudIntParent.typeParent')"
                            :rules="emptyField"
                            persistent-hint
                            single-line
                            color="grey"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="2">
                          <v-checkbox
                            id="intparent-validated"
                            v-model="editedItem.validated"
                            :label="$t('crudIntParent.validatedParent')"
                            color="red darken-1"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            v-model="datePickerStart"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-card-text>
                                <v-text-field
                                  id="intparent-dateStart"
                                  v-model="editedItem.dateStart"
                                  :label="$t('crudIntParent.dateStartParent')"
                                  prepend-icon="mdi-calendar"
                                  color="grey"
                                  :rules="emptyField"
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </v-card-text>
                            </template>

                            <v-date-picker
                              v-model="editedItem.dateStart"
                              :locale="i18nRender.locale"
                              :max="editedItem.dateEnd"
                              color="red darken-1"
                              @input="datePickerStart = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            v-model="datePickerEnd"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-card-text>
                                <v-text-field
                                  id="intparent-dateEnd"
                                  v-model="editedItem.dateEnd"
                                  :label="$t('crudIntParent.dateEndParent')"
                                  :rules="emptyField"
                                  prepend-icon="mdi-calendar"
                                  color="grey"
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </v-card-text>
                            </template>

                            <v-date-picker
                              v-model="editedItem.dateEnd"
                              :locale="i18nRender.locale"
                              :min="editedItem.dateStart"
                              color="red darken-1"
                              @input="datePickerEnd = false"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="close">
                      {{ $t("crudIntParent.cancel") }}
                    </v-btn>
                    <v-btn
                      id="button-save-intparent"
                      color="red darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                    >
                      {{ $t("crudIntParent.save") }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
              <!-- End Form -->
            </v-dialog>
            <!-- Start Dialog Delete -->
            <v-dialog v-model="dialogDelete" max-width="800px">
              <v-card v-if="editedItem && isItemSelected" class="card-delete">
                <v-card-title class="headline">{{
                  $t("crudIntParent.confirmDelete")
                }}</v-card-title>

                <v-card elevation="1" class="py-7 px-9">
                  <v-row>
                    <h2
                      class="intparent-details-title text-decoration-underline"
                    >
                      <a
                        target="_blank"
                        :href="
                          Links.DawanOrgShowTrainingSession(
                            editedItem.slug.split('-customers-')[0]
                          )
                        "
                        >#{{ editedItem.id }} -
                        {{ editedItem.slug.split("-customers-")[0] }}</a
                      >
                    </h2>
                  </v-row>
                  <div class="lstChildrenToDelete">
                    <div class="mt-10">
                      <div class="subtitle-1 font-weight-bold">
                        {{ $t("intParentDetail.subInterventionsList") }}
                      </div>
                      <div
                        class="subtitle-1 font-weight-bold mx-10 my-3"
                        v-if="subInterventions.length === 0"
                      >
                        {{ $t("intParentDetail.emptyList") }}
                      </div>

                      <v-card
                        v-for="intervention in subInterventions"
                        :key="intervention.id"
                        class="mx-10 my-3"
                        elevation="0"
                      >
                        <div
                          class="text-subtitle text-decoration-underline font-weight-bold ma-0"
                        >
                          <a
                            target="_blank"
                            :href="
                              Links.DawanOrgShowTrainingSession(
                                intervention.slug.split('-customers-')[0]
                              )
                            "
                            >#{{ intervention.id }} -
                            {{ intervention.slug.split("-customers-")[0] }}</a
                          >
                        </div>

                        <div class="mt-10">
                          <div class="subtitle-1 font-weight-bold mx-10 my-3">
                            {{
                              $t("intParentDetail.followedInterventionsList")
                            }}
                          </div>
                          <div
                            class="subtitle-1 font-weight-bold mx-15 my-3"
                            v-if="
                              interventionsFollowedLinkedOfSubIntervention.length ===
                              0
                            "
                          >
                            {{
                              $t(
                                "intParentDetail.emptyInterventionsFollowedOfSubInterventionList"
                              )
                            }}
                          </div>

                          <v-card
                            v-for="iFollowed in interventionsFollowedLinkedOfSubIntervention"
                            :key="iFollowed.id"
                            class="mx-10 my-3"
                            elevation="0"
                          >
                            <div
                              class="text-subtitle text-decoration-underline font-weight-bold ma-0 mx-15 my-3"
                            >
                              <a
                                target="_blank"
                                :href="
                                  Links.DawanOrgShowTrainingSession(
                                    iFollowed.advInterventionDto.slug.split(
                                      '-customers-'
                                    )[0]
                                  )
                                "
                                >#{{ iFollowed.id }} -
                                {{ iFollowed.registrationSlug }}</a
                              >
                            </div>
                            <!-- <v-row class="my-7">
                        <v-divider></v-divider>
                      </v-row> -->
                          </v-card>
                        </div>

                        <div class="mt-10">
                          <div class="subtitle-1 font-weight-bold mx-10 my-3">
                            {{ $t("intParentDetail.tasksList") }}
                          </div>

                          <div
                            class="subtitle-1 font-weight-bold mx-15 my-3"
                            v-if="tasksLinkedOfSubIntervention.length === 0"
                          >
                            {{
                              $t(
                                "intParentDetail.emptyTasksOfSubInterventionList"
                              )
                            }}
                          </div>

                          <v-card
                            v-for="task in tasksLinkedOfSubIntervention"
                            :key="task.id"
                            class="mx-10 my-3"
                            elevation="0"
                          >
                            <div
                              class="text-subtitle text-decoration-underline font-weight-bold ma-0 mx-15 my-3"
                            >
                              <a
                                target="_blank"
                                :href="Links.DawanOrgShowTask(task.slug)"
                                >#{{ task.id }} - {{ task.slug }}</a
                              >
                            </div>
                          </v-card>
                        </div>
                      </v-card>
                    </div>

                    <v-row class="my-7">
                      <v-divider></v-divider>
                    </v-row>

                    <div class="mt-10">
                      <div class="subtitle-1 font-weight-bold">
                        {{ $t("intParentDetail.followedInterventionsList") }}
                      </div>
                      <div
                        class="subtitle-1 font-weight-bold mx-10 my-3"
                        v-if="interventionsFollowedLinked.length === 0"
                      >
                        {{
                          $t("intParentDetail.emptyInterventionsFollowedList")
                        }}
                      </div>

                      <v-card
                        v-for="iFollowed in interventionsFollowedLinked"
                        :key="iFollowed.id"
                        class="mx-10 my-3"
                        elevation="0"
                      >
                        <div
                          class="text-subtitle text-decoration-underline font-weight-bold ma-0"
                        >
                          <a
                            target="_blank"
                            :href="
                              Links.DawanOrgShowTrainingSession(
                                iFollowed.advInterventionDto.slug
                              )
                            "
                            >#{{ iFollowed.id }} -
                            {{ iFollowed.registrationSlug }}</a
                          >
                        </div>
                      </v-card>
                    </div>

                    <v-row class="my-7">
                      <v-divider></v-divider>
                    </v-row>

                    <div class="mt-10">
                      <div class="subtitle-1 font-weight-bold">
                        {{ $t("intParentDetail.tasksList") }}
                      </div>

                      <div
                        class="subtitle-1 font-weight-bold mx-10 my-3"
                        v-if="tasksLinked.length === 0"
                      >
                        {{ $t("intParentDetail.emptyTasksList") }}
                      </div>

                      <v-card
                        v-for="task in tasksLinked"
                        :key="task.id"
                        class="mx-10 my-3"
                        elevation="0"
                      >
                        <div
                          class="text-subtitle text-decoration-underline font-weight-bold ma-0"
                        >
                          <a
                            target="_blank"
                            :href="Links.DawanOrgShowTask(task.slug)"
                            >#{{ task.id }} - {{ task.slug }}</a
                          >
                        </div>
                      </v-card>
                    </div>
                  </div>
                </v-card>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="F44336" text @click="closeDelete">{{
                    $t("crudIntParent.cancel")
                  }}</v-btn>
                  <v-btn
                    id="button-delete-intparent"
                    color="red darken-1"
                    dark
                    class="mb-2"
                    @click="deleteItemConfirm"
                    >{{ $t("crudIntParent.delete") }}</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- End Dialog Delete -->
          </v-toolbar>
        </template>

        <template v-slot:[`item.type`]="{ item }">
          <div v-for="uType in $enumInterventionStatus" :key="uType.value">
            <span v-if="item.type === uType.value">{{ uType.text }}</span>
          </div>
        </template>

        <template v-slot:[`item.validated`]="{ item }">
          <v-simple-checkbox
            v-model="item.validated"
            disabled
          ></v-simple-checkbox>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2 button-update-intparent"
            :aria-label="$t('crudIntParent.editBtn')"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2 button-details-intparent"
            :aria-label="$t('crudIntParent.detailBtn')"
            @click="goToDetails(item.id)"
          >
            mdi-information
          </v-icon>
          <v-icon
            small
            class="button-delete-intparent"
            :aria-label="$t('crudIntParent.deleteBtn')"
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          {{ $t("crudIntParent.noData") }}
        </template>
      </v-data-table>
    </div>
    <!-- End Array -->
  </div>
</template>

<script>
import { getSubInterventionsByMasterId } from "/src/services/planning/InterventionServices.js";
import { getByInterventionId } from "/src/services/planning/TaskServices";
import { getAllInterventionsFollowedByInterventionIdHttp } from "/src/services/planning/InterventionFollowedService.js";
import { mapActions, mapGetters } from "vuex";
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import i18n from "@/i18n";
import CrudIntParentDetail from "./detail/CrudIntParentDetail.vue";
import Links from "@/models/Links";
import { DateTime, Interval } from "luxon";

export default {
  components: {
    NotificationMessage,
    CrudIntParentDetail,
  },
  data: () => ({
    filterTypes: [],
    filterDate: [],
    search: "",
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: i18n.t("crudIntParent.hId"),
        value: "id",
        align: "center",
        sortable: false,
      },
      {
        text: i18n.t("crudIntParent.slugHeader"),
        value: "slug",
        sortable: true,
      },
      { text: i18n.t("crudIntParent.hType"), value: "type", sortable: true },
      {
        text: i18n.t("crudIntParent.hValidated"),
        value: "validated",
        sortable: true,
      },
      {
        text: i18n.t("crudIntParent.hdateStart"),
        value: "dateStart",
        sortable: true,
      },
      {
        text: i18n.t("crudIntParent.hdateEnd"),
        value: "dateEnd",
        sortable: true,
      },
      {
        text: i18n.t("crudIntParent.hActions"),
        value: "actions",
        sortable: false,
      },
    ],
    subInterventions: [],
    interventionsFollowedLinked: [],
    interventionsFollowedLinkedOfSubIntervention: [],
    tasksLinked: [],
    tasksLinkedOfSubIntervention: [],
    editedIndex: -1,
    editedItem: {},
    isItemSelected: false,
    defaultItem: {},
    datePickerStart: false,
    datePickerEnd: false,
    i18nRender: null,
    valid: true,
    emptyField: [(v) => !!v || i18n.t("errorFrontEnd.requiredField")],
    inputText: [
      (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
      (v) =>
        /^[ A-Za-z0-9/-]*$/.test(v) ||
        i18n.t("errorFrontEnd.specialCharacters"),
    ],
    Links: Links,
  }),
  computed: {
    ...mapGetters("eventModule", { masterInterventions: "getMasterEvents" }),
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("courseModule", { courses: "getCourses" }),
    ...mapGetters("userModule", { users: "getUsers" }),
    formTitle() {
      return this.editedIndex === -1
        ? i18n.t("crudIntParent.newIntParent")
        : i18n.t("crudIntParent.updateIntParent");
    },
    types() {
      return [...new Set(this.masterInterventions.map((mi) => mi.type))];
    },
    masterInterventionsFiltered() {
      return this.interventionsFiltered();
    },
  },
  watch: {
    filterDate() {
      this.interventionsFiltered();
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    editedItem: function () {
      if (this.isItemSelected) {
        getSubInterventionsByMasterId(this.editedItem.id).then((res) => {
          this.subInterventions = res.data;
        });
        getByInterventionId(this.editedItem.id).then((res) => {
          this.tasksLinked = res.data;
        });
        getAllInterventionsFollowedByInterventionIdHttp(
          this.editedItem.id
        ).then((res) => {
          this.interventionsFollowedLinked = res.data;
        });
      }
    },
    subInterventions: function () {
      this.subInterventions.forEach((interv) => {
        getByInterventionId(interv.id).then((res) => {
          this.tasksLinkedOfSubIntervention = res.data;
        });
        getAllInterventionsFollowedByInterventionIdHttp(interv.id).then(
          (res) => {
            this.interventionsFollowedLinkedOfSubIntervention = res.data;
          }
        );
      });
    },
  },
  mounted() {},
  created() {
    this.loadLocations();
    this.loadCourses();
    this.loadUsers();
    this.i18nRender = i18n;
    this.initialize();
  },
  methods: {
    ...mapActions("eventModule", ["loadEventsMasterCrud"]),
    ...mapActions("eventModule", [
      "addEvent",
      "editEvent",
      "deleteEventMaster",
    ]),
    ...mapActions("locationModule", ["loadLocations"]),
    ...mapActions("courseModule", ["loadCourses"]),
    ...mapActions("userModule", ["loadUsers"]),

    interventionsFiltered() {
      let filtered = this.masterInterventions;
      if (this.filterTypes.length > 0)
        filtered = filtered.filter((mi) => this.filterTypes.includes(mi.type));

      if (this.filterDate.length > 1)
        filtered = filtered.filter((mi) => {
          const innerInterval = Interval.fromDateTimes(
            DateTime.fromISO(mi.dateStart),
            DateTime.fromISO(mi.dateEnd)
          );
          const outerInterval = Interval.fromDateTimes(
            DateTime.fromISO(this.filterDate[0]),
            DateTime.fromISO(this.filterDate[1])
          );
          if (outerInterval.engulfs(innerInterval)) return mi;
        });
      return filtered;
    },
    getCourseTitle(courseId) {
      return this.courses.find((c) => c.id == courseId).title;
    },
    getTrainer(userId) {
      return this.users.find((u) => u.id === userId).fullName;
    },
    getTrainerPicture(userId) {
      const img = this.users.find((u) => u.id === userId).imagePath;

      if (img != undefined) return img;
    },
    getLocation(locId) {
      return this.locations.find((l) => l.id === locId).city;
    },
    getLocationColor(locId) {
      return this.locations.find((l) => l.id === locId).color;
    },
    initialize() {
      this.loadEventsMasterCrud();
    },
    editItem(item) {
      this.editedIndex = this.masterInterventions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.editedItem.master = true;
    },
    deleteItem(item) {
      this.editedIndex = this.masterInterventions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.isItemSelected = true;
    },
    deleteItemConfirm() {
      this.deleteEventMaster(this.editedItem.id);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.isItemSelected = false;
    },
    save() {
      this.editedItem.master = true;
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.editEvent(this.editedItem);
        } else {
          this.addEvent(this.editedItem);
        }
        this.close();
        this.$refs.form.reset();
      }
    },
    goToDetails(interventionId) {
      this.$router.push({
        name: "CrudViewEventsParentDetail",
        params: { id: interventionId },
      });
    },
  },
};
</script>

<style>
.crud {
  width: 100%;
  padding-top: 3rem;
}

.crudArray {
  margin: 3rem auto;
  width: 80%;
}

.notification {
  width: 100%;
  position: absolute;
  padding: 0 1.5rem;
}

.lstChildrenToDelete {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
